/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiFunctionalGrp.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-functional-grp";

export class AutogenModelEdiFunctionalGrp<RowType extends ModelRow> extends Endpoint<RowType, RowEdiFunctionalGrpFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiFunctionalGrp extends ModelRow<RowEdiFunctionalGrpFields> {
	constructor(values?: Partial<RowEdiFunctionalGrpFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiFunctionalGrpFields {
	company_id: string;
	control_number: number;
	direction: string;
	edi_log_id: string;
	func_group_date: Date;
	functional_type: string;
	header: string;
	id: string;
	interchange_id: string;
	receiver_id: string;
	sender_id: string;
	sequence: number;
	trailer: string;
	version: string;
}

